import { tv } from "@/utils/tv.config";

export const accordionClasses = tv({
  base: [
    "Accordion__Root",
    "flex",
    "w-full",
    "flex-col",
    "justify-center",
    "text-gray-900",
  ],
  variants: {},
});
